import { Sparkles } from 'lucide-react';

/**
 * Contador de consultas IA del estudio (cupo mensual compartido) + fecha de renovación.
 * Recibe el objeto `data` de /api/asistente/estado o /api/casos/estado.
 */
export default function CupoIA({ data }) {
  if (!data || data.cupo_mensual == null) return null;
  const usado = data.usado_mes ?? 0;
  const cupo = data.cupo_mensual;
  const restantes = data.restantes ?? Math.max(0, cupo - usado);
  const pct = cupo ? Math.min(100, Math.round((usado / cupo) * 100)) : 0;
  const alerta = restantes <= Math.max(3, Math.round(cupo * 0.1));

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 mb-4 rounded-xl border border-white/10 bg-white/[0.03]">
      <Sparkles className={`w-4 h-4 shrink-0 ${alerta ? 'text-amber-400' : 'text-[#C9A44C]'}`} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <span className="text-[13px] text-[#D8D1C3]">
            Consultas IA del estudio:{' '}
            <strong className={alerta ? 'text-amber-400' : 'text-[#E0C878]'}>{usado}/{cupo}</strong>
            {restantes === 0 && <span className="text-amber-400"> · cupo agotado</span>}
          </span>
          {data.renueva_texto && (
            <span className="text-[11px] text-[#888]">Se renuevan el {data.renueva_texto}</span>
          )}
        </div>
        <div className="mt-1.5 h-1 rounded-full bg-white/10 overflow-hidden">
          <div className={`h-full ${alerta ? 'bg-amber-400' : 'bg-[#C9A44C]'}`} style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
}
